/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Organization-owned Anthropic inference hook. Signing secrets are write-only and encrypted at rest.
 */
export type AnthropicInferenceConfig = {
  enabled: boolean;
  hasSigningSecret: boolean;
  /**
   * Integration identifier. Omitted before setup.
   */
  id?: string | undefined;
  /**
   * Webhook path on the API server. Omitted before setup.
   */
  webhookPath?: string | undefined;
};

/** @internal */
export const AnthropicInferenceConfig$inboundSchema: z.ZodMiniType<
  AnthropicInferenceConfig,
  unknown
> = z.pipe(
  z.object({
    enabled: z.boolean(),
    has_signing_secret: z.boolean(),
    id: z.optional(z.string()),
    webhook_path: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "has_signing_secret": "hasSigningSecret",
      "webhook_path": "webhookPath",
    });
  }),
);

export function anthropicInferenceConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnthropicInferenceConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnthropicInferenceConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnthropicInferenceConfig' from JSON`,
  );
}
